// #!/usr/bin/env node
/*
 * NsUI | 不一样的HTML5 UI框架
 * @作者：             丘宇文
 * @QQ：               80232265
 * @QQ群：             145676463
 * @社区地址：         https://nishi.io
 * @文档地址：         https://nsui.nishi.io
 * @github地址：       https://github.com/kejiaren/NsUI
*/

import Alert from "./alert";            // 警告框

import Badge from "./badge";            // 徽章

import Checkbox from "./checkbox";     // 复选框

import Count from "./count";            // 计数

import DPR from "./dpr";                // 计算DPR

import Dropdown from "./dropdown";      // 下拉菜单

import From from "./from";              // 表单

import Grade from "./grade";            // 评分

import input from "./input";            // 输入框

import Message from "./message";        // 信息提示框

import Modal from "./modal";           // 模态框

import Nav from "./nav";               // 导航

import Radio from "./radio";           // 单选框

import Select from "./select";         // 下拉选框

import Switch from "./switch";         // 开关

import Tree from "./tree";             // 树形菜单

import Uploading from "./uploading";   // 上传

import "../sass/nsui.sass"
import "../fonts/iconfont.css"


// WEBPACK FOOTER //
// src/js/nsui.js